/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './FileDetail.scss';

import FileModel from '../../../models/FileModel';
import { AppNavSubmitButton, AppNavCancelButton } from '../../components/appNav/appNavBits/AppNavButtons';
import ClickableIcon from '../../components/ClickableIcon';
import IconTrash from '../../components/icons/IconTrash';
import DeleteModal from '../../components/modal/DeleteModal';

import { Card, Icons } from '../../../bphComponents/bundle';
import { FileShareCards } from '../components/attributes/ShareCardSelection';
import { FileViewFlaggedControl } from '../components/attributes/Flagged';
import { FileMetadata } from './components/FileMetadata';

import { AttachmentsForFile } from '../components/attributes/Attachments';
import FileActions from '../../appAuthorized/redux/FileActions';
import RouteNames from '../../appAuthorized/RouteNames';
import { useNavigate } from '../../hooks/useNavigate';
import { AppNavFileDetail } from './components/AppNavFileDetail';
import COLORS from '../../styles/Colors';
import ContentWrapper from '../../components/ContentWrapper';
import { useShareCardListForActiveProfile } from '../../hooks/useShareCard';
import { queryCache } from 'react-query';

const FileFooter = (props) => {
  const { file, setFileData, setShowModal } = props;

  return (
    <Card.CardContent>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <FileViewFlaggedControl
          isFlagged={file.data.flagged}
          onClick={() => {
            const newFile = new FileModel(file.data);
            newFile.toggleFlag();
            setFileData(newFile.data);
          }}
        />
        <ClickableIcon align="right" onClick={() => { setShowModal(true); }}>
          <IconTrash.Medium color="gsLightest" />
        </ClickableIcon>
      </div>
    </Card.CardContent>
  );
};

const FileDetail = (props) => {
  const { profileId, onClose, languageCode } = props;

  const [fileData, setFileData] = React.useState(props.file.data);
  const [showModal, setShowModal] = React.useState(false);
  const [, navActions] = useNavigate();
  const [scState, scActions] = useShareCardListForActiveProfile();
  const file = new FileModel(fileData);
  const shareCardList = scActions.shareCardsAvailableForFiles();

  const handleOnSubmit = () => {
    if (!fileData.name) { return; }
    FileActions.submitFileChanges(fileData, () => {
      queryCache.invalidateQueries('files');
      onClose();
    });
  };

  const updateShareCard = (scData) => {
    scActions.apiUpdate(scData);
  };

  if (!scState.isLoaded) { return null; }

  return (
    <div className="cmp-filedetail bkgd-color-profile-accent" style={{ height: 'auto' }}>
      <AppNavFileDetail>
        <AppNavCancelButton
          onClick={onClose}
          color="white"
        />
        <AppNavSubmitButton
          onClick={handleOnSubmit}
          isDisabled={!fileData.name}
        />
      </AppNavFileDetail>

      <ContentWrapper>
        <FileMetadata file={file} setFileData={setFileData} showComments={true} nameHasAutoFocus={false} />

        <AttachmentsForFile fileId={file.data.id} languageCode={languageCode} />

        <Card.ExternalCardTitle className="font-color-gsLightest">
          <FormattedMessage id="healthEntry.addToShareCards.name.text" />
          <Icons.IconShare.Small color={COLORS.gsLightest} />
        </Card.ExternalCardTitle>

        <FileShareCards
          fileId={file.data.id}
          setFileData={setFileData}
          updateShareCard={updateShareCard}
          shareCardList={shareCardList}
        />

        <FileFooter file={file} setFileData={setFileData} setShowModal={setShowModal} />
      </ContentWrapper>

      <DeleteModal
        isVisible={showModal}
        onConfirmAction={() => {
          FileActions.deleteFile(profileId, file.data, () => {
            navActions.goBack(RouteNames.myBackpackAll());
          });
        }}
        onCancelAction={() => {
          setShowModal(false);
        }}
      />
    </div>
  );
};

export default FileDetail;
